import React from 'react';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import { SettingsBreadcrumbs } from '../settingsModule';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import ClientPortalConfigurationForm from './Domain/ClientPortalConfigurationForm';
import useFeatureToggleService from 'feature-toggle';
import ClientPortalThemeForm, {
  ClientPortalLogosForm,
  ResetColorsButtonPortal
} from './Branding/ClientPortalThemeForm';
import { RelativeRow, SimpleBlock, usePopupManager } from "ui-builder";
import BorderedBox from "../../shared/web/layout/BorderedBox";
import { Branding } from "./Domain/clientPortalService";
import ClientPortalPreview from "./Branding/ClientPortalPreview";
import { IconButton, IconType, Popup } from "features/nekst-widgets";
import styles from "./ClientPortalConfigurationPage.module.scss"

function FullPreviewButton(props: {
  data: Branding
}) {
  const popupManager = usePopupManager();

  const handlePreviewClick = React.useCallback(() => {
    popupManager.openPopup(
      <Popup
        title="Branding Preview"
        isCentered={false}
        isBig={true}
        isLong
        content={<ClientPortalPreview branding={props.data} showSwitcher />}
      />
    );
  }, [props.data]);

  return (
    <IconButton
      onClick={handlePreviewClick}
      type={IconType.EXPAND}
    />
  );
}

export function ClientPortalBrandingPage() {

  const [branding, setBranding] = React.useState<Branding>();


  const featureToggle = useFeatureToggleService();


  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Client Portal Branding" />
      </SettingsBreadcrumbs>
      <InnerBlock title="Client Portal Branding">

        {featureToggle.isClientPortalBrandingEnabled() ? (
          <SimpleBlock className={styles.rows}>
            <RelativeRow weights={[6, 6]} useFlex>
              <BorderedBox title="Subdomain">
                <ClientPortalConfigurationForm />
              </BorderedBox>
              <BorderedBox title="Logos">
                <ClientPortalLogosForm />
              </BorderedBox>
            </RelativeRow>
            <RelativeRow weights={[5, 7]} useFlex>
              <BorderedBox
                title="Color Theme"
                headerRight={<ResetColorsButtonPortal />}
              >
                <ClientPortalThemeForm onBrandingUpdated={setBranding} />
              </BorderedBox>
              <BorderedBox
                title="Live Preview"
                headerRight={branding ? <FullPreviewButton data={branding} /> : undefined}
              >
                {branding?.theme &&
                  <ClientPortalPreview branding={branding} showSwitcher={false} platformMode="mobile" />}
              </BorderedBox>
            </RelativeRow>
          </SimpleBlock>
        ) : null}

        {!featureToggle.isClientPortalBrandingEnabled() ? (
          <ClientPortalConfigurationForm />
        ) : null}

      </InnerBlock>
    </>
  );
}
